module.exports = __webpack_public_path__ + "img/content2.2fc629b6.png";